<script setup lang="ts">
import { Footer } from "@/components"
</script>

<template>
  <div class="flex flex-col bg-footer-bg text-primary font-heading">
    <main class="min-h-screen flex items-center py-6 md:py-10 lg:py-0">
      <div class="mx-auto w-full max-w-6xl px-4 md:px-6">
        <slot />
      </div>
    </main>
    <Footer />
  </div>
</template>
